/**
 *
 * 重构生成器页面的内容过滤 以及样式重新编写
 * 主要参考 proContents 方法
 */
//去掉空格、制表符、换页符等等
export const noSpaceOrFeed = content => {
    let newContent = ''
    try {
        newContent = content.replace(/\s+/g, ' ') //\s 匹配任何空白字符，包括空格、制表符、换页符等等。等价于 [ \f\n\r\t\v]。
        newContent = newContent.replace(/&nbsp;/g, '')
        newContent = newContent.replace(/\r|\n|\f|\t|\v|\\r|\\n/g, '') //\s在部分手机处理不好
    } catch (err) {
        newContent = content
    }
    return newContent
}

//去掉所有的行内 style 属性
export const noStyle = content => {
    let newContent = ''
    try {
        //https://blog.csdn.net/weixin_34174422/article/details/92504683   参考写法
        // eslint-disable-next-line no-useless-escape
        newContent = content.replace(/<[^>]*>/gi, match => match.replace(/style="(.*?)\"|style='(.*?)\'/g, '')) // 这种是在下面注释的内容上优化的
        // newContent = setContent.replace(/style="(.*?)\"|style='(.*?)\'/g, '') //setContent.replace(/style="(.*?)\"/g, " ") // 这种过滤方式会吧内容中的  style='xxxx' 也过滤掉
    } catch (err) {
        newContent = content
    }
    return newContent
}

//去掉所有的 class lang 属性
export const noClass = content => {
    let newContent = ''
    try {
        // eslint-disable-next-line no-useless-escape
        newContent = content.replace(/<[^>]*>/gi, match => match.replace(/class="(.*?)\"|class='(.*?)\'/g, '')) // 这种是在下面注释的内容上优化的
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/<[^>]*>/gi, match => match.replace(/lang="(.*?)\"|lang='(.*?)\'/g, '')) // 这种是在下面注释的内容上优化的
    } catch (err) {
        newContent = content
    }
    return newContent
}

//移除所有 <style></style> 标签
export const noStyleTab = content => {
    let newContent = ''
    try {
        // eslint-disable-next-line no-useless-escape
        newContent = content.replace(/<style>(.*?)\<\/style>/g, '')
    } catch (err) {
        newContent = content
    }
    return newContent
}

// //去掉所有的空段落 以及段落标签处理
export const noEmptySection = content => {
    let newContent = ''
    try {
        newContent = content.replace(/<^>+><\/^>+>/g, '') //去掉所有空标签
        newContent = newContent.replace(/<p {1,5}>/g, '<p>') //去掉所有带空格的空段落  <p   ></p> // 处理这种
        newContent = newContent.replace(/<p><\/p>/g, '') //去掉所有空段落
    } catch (err) {
        newContent = content
    }
    return newContent
}

//处理 table 标签 生成新的结构
export const calcTable = content => {
    let newContent = ''
    try {
        // eslint-disable-next-line no-useless-escape
        newContent = content.replace(/<table[^>]*>/gi, match => match.replace(/cellspacing="(.*?)\"|cellspacing='(.*?)\'/g, ''))
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/<table[^>]*>/gi, match => match.replace(/cellpadding="(.*?)\"|cellpadding='(.*?)\'/g, ''))
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/<table[^>]*>/gi, match => match.replace(/border="(.*?)\"|border='(.*?)\'/g, ''))
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/\<table/g, '<div class="hanni_table"><div><table border="0" cellspacing="0" cellpadding="0"') //border="0" cellspacing="0" cellpadding="0"
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/\<\/table>/g, '</table></div></div>')
    } catch (err) {
        console.error(err)
        newContent = content
    }
    return newContent
}

// 修改table的合并单元格的效果
export const editTable = content => {
    let newContent = ''
    try {
        newContent = content.replace(/rowspan=/g, 'class="addRowspan" rowspan=') //给table带有合并单元格的标签增加一个强制的样式
    } catch (err) {
        newContent = content
    }
    return newContent
}

/** 处理 H5 生成器的内容 */
export const proContents = ({ text }) => {
    let newContent = ''
    if (text) {
        /**
         * 此处的执行顺序不要随意调换
         * 注：采用多个 try catch 是为了避免其中一个出现错误的时候，其余的过滤逻辑仍然可以继续执行过滤
         */
        newContent = noSpaceOrFeed(text)
        newContent = noStyle(newContent)
        newContent = noClass(newContent)
        newContent = noStyleTab(newContent)
        newContent = noEmptySection(newContent)
        newContent = calcTable(newContent)
        newContent = editTable(newContent)
    }

    return newContent
}

//删除所有html标签 -- 暂未用到
export const noHtml = ({ text }) => {
    const reg = /<\/?.+?\/?>/g //匹配所有的html标签
    return text?.replace(reg, '') || ''
}
